module.exports = __webpack_public_path__ + "static/media/vacciplant.f94433bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/climasense/botrytis_pimiento/preventiva/vacciplant.png
// module id = 1439
// module chunks = 3